import { FOOD_INPUT_REFERENCE_SOURCE_KEYS } from "../../../../constants/foodSourceConstants";

export const INPUT_REFERENCE_INGESTION_HREF = "#/admin/food-input-ingestion";

export function parseInputReferenceApiError(error) {
  if (!error) {
    return "Input reference request failed.";
  }
  if (typeof error === "string") {
    return error;
  }
  return error.message || "Input reference request failed.";
}

export function getInputReferenceRunResultMessage(result) {
  if (!result) {
    return null;
  }

  const ingestion = result.ingestion || result;
  const inserted = ingestion.observationsInserted ?? ingestion.recordsParsed ?? 0;
  const status = ingestion.status || (result.success ? "completed" : "error");
  const mockNote = result.useMock ? " (mock data)" : "";

  let message = `Input reference ingestion ${status}: ${inserted} records${mockNote}.`;

  if (result.trends?.trendsCalculated != null) {
    message += ` Trends: ${result.trends.trendsCalculated}.`;
  }

  return message;
}

export function isInputReferenceSourceKey(sourceKey) {
  return Object.values(FOOD_INPUT_REFERENCE_SOURCE_KEYS).includes(
    String(sourceKey || "").trim()
  );
}

export function getInputReferenceCategoryForSource(sourceKey) {
  const normalized = String(sourceKey || "").trim();
  if (normalized === FOOD_INPUT_REFERENCE_SOURCE_KEYS.PACKAGING) {
    return "PACKAGING";
  }
  return "FUEL";
}
